module.exports = __webpack_public_path__ + "static/media/3Ikon.74641959.JPG";